'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _moment = _interopRequireDefault(require("moment"));
var _Table = _interopRequireDefault(require("@material-ui/core/Table"));
var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _TablePagination = _interopRequireDefault(require("@material-ui/core/TablePagination"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _EnhancedTableHead = _interopRequireDefault(require("Components/Lists/EnhancedTableHead"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _DeleteNewsModal = _interopRequireDefault(require("Modals/DeleteNewsModal"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _utilities = require("Shared/utilities");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
_moment.default.locale('fr');
const TablePagination_props = {
  backIconButtonProps: {
    'aria-label': 'Page précédente'
  },
  nextIconButtonProps: {
    'aria-label': 'Page suivante'
  }
};
const columns = [{
  id: 'title',
  numeric: false,
  label: 'Titre ',
  align: 'left'
}, {
  id: 'date',
  numeric: false,
  label: 'Date'
}, {
  id: 'visibility',
  numeric: false,
  label: 'Statut'
}, {
  id: 'actions',
  numeric: false,
  label: ''
}].map(o => ({
  ...o,
  align: o.align || 'center',
  sortable: (0, _utilities.isTrue)(o.sortable)
}));
class News extends _react.Component {
  state = {
    loading: false,
    openDeleteNewsModal: false,
    selected: [],
    news: [],
    news_count: 0,
    page: 0,
    rows_per_page: 25,
    order: 'desc',
    order_by: 'date'
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchNews({});
  }
  fetchNews = ({
    page,
    order,
    order_by
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    page = typeof page === 'undefined' ? state.page : page;
    order = order || state.order;
    order_by = order_by || state.order_by;
    component.setState({
      loading: true
    });
    qwest.post('/news/get-all', {
      limit: state.rows_per_page,
      skip: state.rows_per_page * page,
      with_count: true,
      order: order,
      order_by: order_by
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        news: response.news,
        news_count: response.count
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  openDeleteNewsModal = ({
    news_id,
    e
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      openDeleteNewsModal: true,
      delete_modal_news: news_id,
      delete_modal_trigger: e.target
    });
  };
  closeDeleteNewsModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      openDeleteNewsModal: false,
      delete_modal_news: undefined,
      delete_modal_trigger: undefined
    });
    component.fetchNews({});
  };
  handleChangePage = (e, page) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      page: page
    });
    component.fetchNews({
      page: page
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const empty_rows = state.rows_per_page - Math.min(state.rows, state.news_count - state.page * state.rows_per_page);
    _moment.default.locale('fr');
    const rows = (state.news || []).map(function (data) {
      const link = /*#__PURE__*/_react.default.createElement(_Link.default, {
        href: '/contenu/liste-des-actualites/' + data.id,
        className: "u-link-only"
      });
      let output = /*#__PURE__*/_react.default.createElement(_TableRow.default, {
        hover: true,
        tabIndex: -1,
        key: data.id
      }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "left"
      }, data.title, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, (0, _moment.default)(data.date).format('DD/MM/YYYY'), link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, (0, _utilities.isTrue)(data.visibility) ? 'Publiée' : 'Masquée', link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        variant: "text",
        color: "secondary",
        onClick: e => component.openDeleteNewsModal({
          news_id: data.id,
          e: e
        })
      }, /*#__PURE__*/_react.default.createElement(_Delete.default, {
        color: "secondary"
      }))));
      return output;
    });
    let output = /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "dashboard-table",
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Table.default, {
      "aria-labelledby": "Actualites"
    }, /*#__PURE__*/_react.default.createElement(_EnhancedTableHead.default, {
      onRequestSort: component.handleRequestSort,
      order: state.order,
      order_by: state.order_by,
      row_count: rows.length,
      columns: columns
    }), /*#__PURE__*/_react.default.createElement(_TableBody.default, null, rows, empty_rows > 0 ? /*#__PURE__*/_react.default.createElement(_TableRow.default, {
      style: {
        height: 49 * empty_rows
      }
    }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      colSpan: 4
    })) : undefined)), /*#__PURE__*/_react.default.createElement(_TablePagination.default, _extends({
      onPageChange: component.handleChangePage,
      component: "div",
      count: state.news_count,
      rowsPerPage: state.rows_per_page,
      rowsPerPageOptions: [],
      page: state.page,
      labelDisplayedRows: ({
        from,
        to,
        count
      }) => from + '-' + to + ' sur ' + count
    }, TablePagination_props)), /*#__PURE__*/_react.default.createElement(_DeleteNewsModal.default, {
      news_to_delete: state.delete_modal_news,
      open: state.openDeleteNewsModal,
      onClose: component.closeDeleteNewsModal,
      delete_modal_trigger: state.delete_modal_trigger
    }));
    return output;
  }
}
exports.default = News;
